import { Component } from '@angular/core';
import { INoRowsOverlayAngularComp } from 'ag-grid-angular';


@Component({standalone: false,
  selector: 'app-dropdown-renderer',
  template: ` <span>{{ value }}</span> `,
})
export class DropdownRendererComponent implements INoRowsOverlayAngularComp {
  value: any;

  agInit(params): void {
    this.value = params.value;
  }

}
